module.exports = __webpack_public_path__ + "img/login_person.8b46d7f3.png";